import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['panel'];

  open(event) {
    const self = this;
    const element = event.target;
    self.panel = window.$(self.panelTarget);
    const url = element.dataset.dockedPanelUrl;
    const obfuscation =
      element.dataset.dockedPanelObfuscation === 'false' ? 'false' : 'true';
    this.data.set('enableObfuscation', obfuscation);
    self.panel.addClass('docked-panel--open');
    self.panel.addClass('docked-panel--loading');
    if (this.data.get('enableObfuscation') !== 'false')
      window.$(this.element).addClass('obfuscate');
    self.panel.load(url, () => {
      // eslint-disable-next-line no-undef
      $('body').trigger('ajax-content-loaded', self.panelTarget);
      self.panel.removeClass('docked-panel--loading');
    });
  }

  close() {
    const self = this;
    self.panel = window.$(self.panelTarget);
    self.panel.removeClass('docked-panel--open');
    if (this.data.get('enableObfuscation') !== 'false')
      window.$(this.element).removeClass('obfuscate');
  }
}
